import GnlKullaniciAyarDTO from 'src/models/Base/Auth/GnlKullaniciAyarDTO';
import { ApiService } from 'src/services/core';

class KullaniciAyarService extends ApiService<GnlKullaniciAyarDTO>{
    constructor() {
        super('GnlKullaniciAyarDTO');
    }
}
export default new KullaniciAyarService();